/**
 * User domain model
 */
export class User {
  constructor(
    public readonly id: string,
    public readonly email: string,
    public readonly name: string,
  ) {}

  /**
   * Create User from API response
   */
  static fromApiResponse(data: UserApiData): User {
    return new User(
      data.id,
      data.email,
      data.name,
    )
  }

  /**
   * Convert to plain object for storage
   */
  toPlainObject(): UserData {
    return {
      id: this.id,
      email: this.email,
      name: this.name,
    }
  }

  /**
   * Create User from stored data
   */
  static fromStoredData(data: UserData): User {
    return new User(
      data.id,
      data.email,
      data.name,
    )
  }

  /**
   * Check if user is valid
   */
  isValid(): boolean {
    return (
      !!this.id &&
      !!this.email &&
      !!this.name
    )
  }
}

/**
 * User data structure for storage
 */
export interface UserData {
  id: string
  email: string
  name: string
}

/**
 * User data from API
 */
export interface UserApiData {
  id: string
  email: string
  name: string
}
